import * as React from 'react';
import { Loading } from '../UI/loading';

const IFrame2 = ({ url }) => {
  const [data, setData] = React.useState({
    isLoading: true,
    url: url,
  });

  const hideLoading = () => {
    setData({
      ...data,
      isLoading: false,
    });
  };

  React.useEffect(() => {
    // This
    if (typeof window !== 'undefined') {
      setData({
        ...data,
        url: url + window.location.search,
      });
    }
  }, []);

  // const pathname = location.pathname;
  // const [, , nextScreen] = pathname.split("/");
  // const frame: any = document.getElementsByTagName("iframe");
  // let loansData = {};
  // const dashboardData = localStorage.getItem("DASHBOARD_DATA");
  // let authData = {};

  // try {
  //   const parsedDashboardData = JSON.parse(dashboardData);
  //   loansData = {
  //     authData: JSON.stringify(loansData),
  //     dashboardData: parsedDashboardData,
  //     env: "qa",
  //   };

  //   authData = {
  //     authData: localStorage.getItem(STORAGE_KEYS.AUTH_CONFIG),
  //     dashboardData: parsedDashboardData ? parsedDashboardData.data : {},
  //     env: "qa",
  //   };
  // } catch (e) {
  //   console.warn("error parsing dashboarddata", e);
  // }
  // React.useEffect(() => {
  //   window.addEventListener("message", (event) => {
  //     const action = get(event, "data.action", "");

  //     if (action === "get_detail") {
  //       setTimeout(() => {
  //         const [container] = frame;
  //         if (container.contentWindow) {
  //           container.contentWindow.postMessage(
  //             {
  //               call: "sendValue",
  //               value: authData,
  //             },
  //             "*",
  //           );
  //         }
  //       }, 3000);
  //     } else if (action === "close_app") {
  //       history.pushState("", "", nextScreen ? `/${nextScreen}` : "/");
  //       var popStateEvent = new PopStateEvent("popstate", {});
  //       dispatchEvent(popStateEvent);
  //     }
  //   });
  // }, []);
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
      }}
    >
      {data.isLoading && <Loading />}
      <iframe style={{ height: '100%', width: '100%' }} onLoad={hideLoading} src={data.url}></iframe>
    </div>
  );
};

export default IFrame2;
